<template>
    <div style="padding: 1rem 1rem 1.5rem;">
        <div v-if="!isLoading">
            <div v-if="hasNoActivities" class="text-center">
                <div style="margin-bottom: 1rem;">No activities planned</div>

                <secondary-pill-button @click="add">+ Schedule activity</secondary-pill-button>
            </div>
            <div style="margin: -1rem;" v-else>
                <table class="table text-left" style="margin: 0; padding: 0; font-size: .9rem; border-top: none;">
                    <tr v-for="activity in futureAndIncompleteActivities">
                        <td style="width: 40px;" @click="updateActivity(activity)">
                            <ui-radio :value="activity.completed_at ? 1 : 0" :trueValue="1" />
                        </td>
                        <td>
                            <a href="#" @click.prevent="$refs.activityModal.open(activity.id)">{{ activity.title }}</a>
                            <div><activity-due-at :show-icon="false" :activity="activity" /></div>
                        </td>
                    </tr>
                </table>

                <div class="text-center" style="margin-top: .5rem;">
                    <secondary-pill-button @click="add">+ Schedule activity</secondary-pill-button>
                </div>
            </div>
        </div>
        <div v-show="isLoading">
            <ui-progress-circular :size="40" style="margin: auto;" :stroke="2"></ui-progress-circular>
        </div>

        <!-- New Activity Modal !-->
        <activity-modal
                ref="activityModal"
                @saved="activitySaved"
                @deleted="activityDeleted"
        />
    </div>
</template>

<script>
import Moment from 'moment';
import ActivityDueAt from "../lead/ActivityDueAt";
import ActivityHelpers from "../lead/ActivityHelpers";
import ActivityModal from "../ActivityModal";
import {ActivityResource} from "../../classes/Api/Activity";

export default {
    mixins: [ActivityHelpers],
    components: { ActivityDueAt, ActivityModal },
    props: {
        contact: {
            required: true,
            type: Object,
        },
        lead: {
            type: Object,
        }
    },
    data() {
        return {
            isLoading: true,
            activities: []
        }
    },
    mounted() {
        this.loadActivities()
    },
    computed: {
        futureAndIncompleteActivities() {
            return this.activities.filter(item => Moment().isBefore(item) || !item.completed_at)
        },
        hasNoActivities() {
            return this.futureAndIncompleteActivities.length === 0
        }
    },
    methods: {
    loadActivities() {
            return new Promise((resolve, reject) => {
                ActivityResource.all({ filters: JSON.stringify({ 'activity.contact': this.contact.id })}).then(r => {
                    this.activities = r.data.results

                    this.isLoading = false
                }).catch(reject)
            })
        },
        updateActivity(activity) {
            this.toggleActivity(activity, activity => {
                if (activity.completed_at) {
                    this.$refs.activityModal.reset()

                    this.$refs.activityModal.open(
                        this.newActivity()
                    )

                    this.activitySaved(activity)
                }
            })
        },
        add() {
            let activity = this.newActivityForContact(this.contact)

            if (this.lead) {
                activity.lead_id = this.lead.id
                activity.lead = this.lead
            }

            this.$refs.activityModal.open(
                activity
            )
        },
        activitySaved(activity) {
            this.loadActivities().then(() => {
                this.$emit('updated', activities)
            })
        },

        activityDeleted(activity) {
            this.loadActivities().then(() => {
                this.$emit('updated', activities)
            })
        },
    }
}
</script>

<style scoped>
    table tr:first-child td { border-top: none; }
</style>